import { render } from "./BasePageHeader.vue?vue&type=template&id=337d4952&scoped=true"
const script = {}

import "./BasePageHeader.vue?vue&type=style&index=0&id=337d4952&lang=scss&scoped=true"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\sas\\wp-content\\themes\\io.shop-standalone-stadtwerk-am-see\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337d4952"]])

export default __exports__